import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetDealerStructuredDataUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Function} deps.dealerEntityFactory
   * @param {FromDealerEntityToStructuredDataValueObjectMapper} deps.fromDealerEntityToStructuredDataValueObjectMapper
   * */
  constructor({config, dealerEntityFactory, fromDealerEntityToStructuredDataValueObjectMapper}) {
    super()
    this._config = config
    this._dealerEntityFactory = dealerEntityFactory
    this._fromDealerEntityToStructuredDataValueObjectMapper = fromDealerEntityToStructuredDataValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {String} param.culture
   * @param {String} param.pageName
   * @param {Object} param.params
   * @return {Promise<[error, data], Error>}
   **/
  @inlineError
  async execute({dealer}) {
    const dealerEntity = this._dealerEntityFactory(dealer)

    const structuredDataVO = this._fromDealerEntityToStructuredDataValueObjectMapper.map({
      dealerEntity
    })

    return structuredDataVO.toJSON()
  }
}
